import {Injectable} from '@angular/core';
import {EventBusPort} from '../../domain/ports/event-bus.port';
import {Subject, Observable, filter, map} from 'rxjs';
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

@Injectable()
export class RxEventBusAdapter extends EventBusPort {
  private bus = new Subject<DomainEvent>();

  publish<T extends DomainEvent>(event: T): void {
    this.bus.next(event);
  }

  ofType<T extends DomainEvent>(
    eventClass: new (...args: unknown[]) => T
  ): Observable<T> {
    return this.bus.asObservable().pipe(
      filter((event) => event instanceof eventClass),
      map((event) => event as T)
    );
  }


}
